import React from 'react';
import { config } from '../config';

interface IProps {
    imageUrl: string;
    alt: string;
    className?: string;
    imageFallback: 'cabin' | string;
}

export const ImgWithFallback = ({ imageUrl, alt, className, imageFallback }: IProps) => {
    const [src, setSrc] = React.useState(imageUrl);

    if (!src) {
        setSrc(`${config.images}/common/placeholder.png`);
    }

    return <img alt={alt} src={src} className={className} onError={() => setSrc(imageFallback)} />;
};
